<template>
    <div id="result">
        <!-- Result ID: Useful for debugging. -->
        <!-- <p class="small mb-3 mb-lg-5">
            {{ result.id }}
        </p> -->
        
        <h4 
            v-if="result.title"
            class="mb-4"
        >
            {{ $t(result.title) }}
        </h4>

        <!-- eslint-disable vue/no-v-html  -->
        <p
            v-if="result.explanation"
            v-html="$t(result.explanation)" 
        />
        <!-- eslint-enable vue/no-v-html  -->
    </div>
</template>

<script>
export default {
    name: 'Result',
    props: {
        result: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
#result {
    @include media-breakpoint-up(xl) {
        min-height: 34rem;
    }
}

p::v-deep a {
    color: $secondary;
}
</style>
